// sort.ts — 한국어(가나다) 정렬 헬퍼.
// Intl.Collator 생성은 비싸므로 모듈 레벨에서 한 번만 만들어 재사용한다.
// numeric: 규격명 안의 숫자를 자연순으로("A2" < "A10"), sensitivity base: 대소문자 무시.
const koCollator = new Intl.Collator("ko", { numeric: true, sensitivity: "base" });

/** 가나다 비교자. null/undefined 는 빈 문자열로 취급해 맨 앞으로 보낸다. */
export const compareKo = (a: string | null | undefined, b: string | null | undefined): number =>
  koCollator.compare(a ?? "", b ?? "");

/** `pick` 라벨 기준 가나다 정렬 — 입력 배열은 건드리지 않고 새 배열을 돌려준다. */
export const sortByKo = <T>(
  items: readonly T[],
  pick: (item: T) => string | null | undefined
): T[] => [...items].sort((a, b) => compareKo(pick(a), pick(b)));
